import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=909e8312&"
import script from "./addBanner.vue?vue&type=script&lang=js&"
export * from "./addBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('909e8312')) {
      api.createRecord('909e8312', component.options)
    } else {
      api.reload('909e8312', component.options)
    }
    module.hot.accept("./addBanner.vue?vue&type=template&id=909e8312&", function () {
      api.rerender('909e8312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addBanner.vue"
export default component.exports